<main>
  <header>
    <h1>Business Structure</h1>
    <h2>Tell us about your business, so we can better support you with a setup that fits your needs.</h2>
  </header>
  
  <form class="application-form" [formGroup]="form" (ngSubmit)="continue()" appPopulateForm [formType]="'businessStructure'" [form]="form">
    
    <!-- Business Structure Field -->
    <div class="field">
      <label for="businessStructure">Business Structure</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-select formControlName="businessStructure" required placeholder="Enter">
          <mat-option [value]="option.value" *ngFor="let option of businessStructureOptions">{{option.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('businessStructure')?.hasError('required')">
          Business Structure is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- SSN -->
    <div class="field" *ngIf="role === 'supplier'">
      <label for="businessSsn">SSN</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessSsn" mask="XXX-XX-XXXX" [hiddenInput]="ssnMasked"
          [patterns]="ssnReplacePattern" placeholder="Enter">
        <button type="button" mat-icon-button class="ssn-eye" matSuffix (click)="toggleSSNVisibility($event)" matTooltip="Show/Hide SSN">
          <img src="icons/lock.svg" alt="Lock Icon" />
        </button>
        <mat-error *ngIf="form.get('businessSsn')?.hasError('pattern')">
          SSN must be 9 digits
        </mat-error>
        <mat-error *ngIf="form.get('businessSsn')?.hasError('required')">
          SSN is required
        </mat-error>
        <mat-error *ngIf="form.get('businessSsn')?.hasError('mask')">
          SSN must be in the format XXX-XX-XXXX
        </mat-error>
      </mat-form-field>

      <p class="field-info" *ngIf="isSoleProp">Your SSN helps us verify your details and prevent fraud. We'll keep your data secure.</p>
      <p class="field-info" *ngIf="!isSoleProp">Providing your SSN (or ITIN) is optional unless you are a sole proprietor. However, including it may help speed up underwriting and certain automated verification checks.</p>
    </div>

    <!-- Business Tax ID Field -->
    <div class="field" *ngIf="!isSoleProp">
      <label for="businessTaxID">Business Tax ID</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessTaxID" placeholder="Enter" mask="00-0000000">
        <mat-error *ngIf="form.get('businessTaxID')?.hasError('required')">
          Business Tax ID is required
        </mat-error>
        <mat-error *ngIf="form.get('businessTaxID')?.hasError('pattern')">
          Business Tax ID must be exactly 9 digits
        </mat-error>
      </mat-form-field>
      <p class="field-info">We need to ask for your Employer Identification Number to verify your identity. We'll keep your data secure.</p>
    </div>

    <!-- Industry Field -->
    <div class="field">
      <label for="industry">Industry</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-select formControlName="industryType" required placeholder="Enter">
          <mat-option [value]="option.value" *ngFor="let option of industryOptions">{{option.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('industryType')?.hasError('required')">
          Industry is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Years in Business Field -->
    <div class="field">
      <label for="yearsInBusiness">Years in Business</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-select formControlName="yearsInBusiness" required placeholder="Enter">
          <mat-option [value]="option.value" *ngFor="let option of yearsInBusinessOptions">{{option.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('yearsInBusiness')?.hasError('required')">
          Years in Business is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Number of Employees Field -->
    <div class="field">
      <label for="numberOfEmployees">Number of Employees</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="numberOfEmployees" required type="number" min="1" placeholder="Enter" (keypress)="onlyNumberKey($event)">
        <mat-error *ngIf="form.get('numberOfEmployees')?.hasError('required')">
          Number of Employees is required
        </mat-error>
        <mat-error *ngIf="form.get('numberOfEmployees')?.hasError('min')">
          Number must be 1 or higher
        </mat-error>
      </mat-form-field>
      <p class="field-info">Include both full-time and part-time employees.</p>
    </div>

    <!-- Gross Annual Revenue Field -->
    <div class="field">
      <label for="grossAnnualRevenue">Gross Annual Revenue</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <!-- prefix the input with a $ -->
        <span matPrefix>&nbsp;</span>
        <!-- bind the displayed value through the currency pipe -->
        <input
          matInput
          [value]="grossAnnualRevenueDisplay"
          (input)="onRevenueInput($event)"
          (blur)="onRevenueBlur()"
          required
          placeholder="$0.00"
        />
        <mat-error *ngIf="form.get('grossAnnualRevenue')?.hasError('required')">
          Gross Annual Revenue is required
        </mat-error>
        <mat-error *ngIf="form.get('grossAnnualRevenue')?.hasError('min')">
          Value must be greater than 0
        </mat-error>
        <mat-error *ngIf="form.get('grossAnnualRevenue')?.hasError('max')">
          Gross Annual Revenue cannot exceed 15 digits
        </mat-error>
      </mat-form-field>
    </div>


    <!-- Referral Number Field (Optional) -->
    <div class="field">
      <label for="referralNumber">Referral Number</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="referralNumber" placeholder="(optional)">
        <mat-error *ngIf="form.get('referralNumber')?.hasError('maxlength')">
          Referral Number cannot exceed 15 characters
        </mat-error>
      </mat-form-field>
    </div>

    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
    >
    </app-form-actions>
  </form>
</main>
